import CompaniesService from "../services/companies";
export const LOADING_COMPANIES = 'LOADING_COMPANIES';
export const LOAD_COMPANIES = 'LOAD_COMPANIES';
export const LOAD_PAGES = 'LOAD_PAGES';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const GET_PAGE = 'GET_PAGE';
export const CHANGE_SORT = 'CHANGE_SORT';
export const SET_COMPANY = 'SET_COMPANY';
export const GET_COMPANY = 'GET_COMPANY';
export const GET_EXCEL = 'GET_EXCEL';

export function getExcel(query){
  return (dispatch) => {
    // dispatch({type: GET_EXCEL});
    CompaniesService.excel(query)
    .then((response)=>{ 
      const href =URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'aserta.xlsx');
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    })
  }
}

export function loadCompanies(query) {
  return (dispatch, getState) => {

    var page = getState().companies.get('page');
    var sort = getState().companies.get('sort');
    if (query)
      query.page = page ? page : null;
    else
      query = {
        page: page ? page : null
      };
    if (sort.length > 0)
      query.ordering =  sort.toString();
    dispatch({ type: LOADING_COMPANIES });
    CompaniesService.list(query)
    .then((response) => {
      let companies = response.results;
      let pages = Math.trunc(response.count / 50);
      if ((response.count % 50) != 0)
        pages += 1;
      dispatch({
        type: LOAD_COMPANIES,
        companies
      });
      dispatch({
        type: LOAD_PAGES,
        pages
      });
    });
  };
}

export function setCompany(id) {
  return (dispatch) => {
    dispatch({ type: LOADING_COMPANIES });
    CompaniesService.get(id)
    .then((response) => {
      var company = response;
      dispatch({
        type: SET_COMPANY,
        company
      });
    });
  };
}

export function removeCompany() {
  return (dispatch) => {
    var company = null;
    dispatch({
      type: SET_COMPANY,
      company
    });
  };
}

export function sortCompanies(sort) {
  return (dispatch) => {
     dispatch({
          type: CHANGE_SORT,
          sort
        });
  };
}

export function changePage(page) {
  return (dispatch) => {
     dispatch({
          type: CHANGE_PAGE,
          page
        });
  };
}



// WEBPACK FOOTER //
// ./actions/companies.js